( function () {

  const LG_BREAKPOINT = 992;

  function updateTagsTop() {
    const tocWrapper = document.querySelector( '.e-col--blog-inner-toc .e-div--blog-inner-toc-sticky-wrapper' );
    const tagBlock = document.querySelector( '.e-col--blog-inner-toc > .e-div--blog-inner-tag' );
    if ( ! tocWrapper || ! tagBlock ) return;

    if ( window.innerWidth < LG_BREAKPOINT ) {
      tagBlock.style.position = '';
      tagBlock.style.top = '';
      return;
    }

    const tocHeight = tocWrapper.offsetHeight;
    const headerOffset = 105;
    const gap = 20;
    tagBlock.style.position = 'sticky';
    tagBlock.style.top = ( headerOffset + tocHeight + gap ) + 'px';
  }

  function createActiveItemTracker() {
    const wrapper = document.querySelector( '.e-col--blog-inner-toc .e-div--blog-inner-toc-sticky-wrapper' );
    if ( ! wrapper ) return null;

    let lastActiveHref = '';

    return function checkActive() {
      const activeLink = wrapper.querySelector( '.toc-block-inner-toc li.active a' );
      if ( ! activeLink ) return;

      const href = activeLink.getAttribute( 'href' ) || '';
      if ( href === lastActiveHref ) return;
      lastActiveHref = href;

      const activeItem = activeLink.parentElement;
      const wrapperRect = wrapper.getBoundingClientRect();
      const itemRect = activeItem.getBoundingClientRect();
      const isVisible = itemRect.top >= wrapperRect.top && itemRect.bottom <= wrapperRect.bottom;
      if ( isVisible ) return;

      const targetScroll = wrapper.scrollTop + ( itemRect.top - wrapperRect.top ) - ( wrapperRect.height / 3 );
      wrapper.scrollTo( { top: targetScroll, behavior: 'smooth' } );
    };
  }

  document.addEventListener( 'DOMContentLoaded', function () {
    updateTagsTop();
    const trackActive = createActiveItemTracker();
    window.addEventListener( 'resize', updateTagsTop );
    window.addEventListener( 'scroll', function () {
      updateTagsTop();
      if ( trackActive ) trackActive();
    } );
  } );
} )();
